import axiosInstance from 'utils/axiosInstance';
import {
  ApproveChange,
  ApproveReplace,
  ChangeListingType,
  ChangeStatusShiftTrackerType,
  CheckandfillshiftType,
  CreateNoteType,
  CreateRemplace,
  CreateShiftTracker,
  CreateShiftType,
  CredentialsDragUser,
  DragUser,
  FiltersDemandeShift,
  FiltersMyShift,
  GetNumberOfUsersToCopyType,
  Publishinfo,
  SaveTemplateType,
  ShiftCopyPeriod,
  ShiftNote,
  ShiftParametres,
  ShiftTableResponse,
  ShiftTracker,
  WorkSchedule,
} from '../types/type';
import { OptionSelect } from 'features/documents/types/document';
import { downloadExcelBuffer } from 'utils/globalMethodes';

export const GetDragUsers = async (
  credentials: CredentialsDragUser,
): Promise<DragUser[]> => {
  const { data } = await axiosInstance.post<ApiResponse<DragUser[]>>(
    'api/shift/draglist',
    credentials,
  );
  return data.data;
};

export const GetRowsService = async (
  filters: CredentialsDragUser,
): Promise<DragUser[]> => {
  const { data } = await axiosInstance.post<ApiResponse<DragUser[]>>(
    '/api/shift/rows',
    filters,
  );
  return data.data;
};

export const GetInfoshiftService = async (
  id: string,
): Promise<WorkSchedule> => {
  const { data } = await axiosInstance.get<ApiResponse<WorkSchedule>>(
    `/api/shift/info/${id}`,
  );
  return data.data;
};

export const GetshiftTrackerService = async (
  id: string,
): Promise<ShiftTracker> => {
  const { data } = await axiosInstance.get<ApiResponse<ShiftTracker>>(
    `/api/Htravail/getshiftTracker/${id}`,
  );
  return data.data;
};

export const checkandfillshiftService = async (
  parameters: object,
): Promise<CheckandfillshiftType> => {
  const { data } = await axiosInstance.post<ApiResponse<CheckandfillshiftType>>(
    '/api/shift/checkandfillshift',
    parameters,
  );
  return data.data;
};

export const getListBySiteService = async (
  id: number,
): Promise<SelectOptionResponse[]> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectOptionResponse[]>>(
    `/api/area/listbysite/${id}`,
  );
  return data.data;
};

export const getListOfFunctionService = async (
  id: number,
): Promise<ApiResponse<SelectOptionResponse[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectOptionResponse[]>>(
    `/api/area/listoffunction/${id}`,
  );
  return data;
};

export const updateShift = async (
  values: CreateShiftType,
): Promise<ApiResponse<string>> => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    '/api/shift/update',
    values,
  );
  return data;
};

export const updateRepos = async (
  values: CreateShiftTracker,
): Promise<ApiResponse<string>> => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    '/api/Htravail/saveshiftTracker',
    values,
  );
  return data;
};

export const saveNoteService = async (
  values: CreateNoteType,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shift/savenote',
    values,
  );
  return data;
};

export const getNoteService = async (date: string): Promise<ShiftNote[]> => {
  const { data } = await axiosInstance.get<ApiResponse<ShiftNote[]>>(
    `/api/shift/notes/${date}`,
  );
  return data.data;
};

export const deleteShiftService = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/shift/delete/${id}`,
  );
  return data;
};

export const deleteshiftTrackerService = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/Htravail/deleteshiftTracker/${id}`,
  );
  return data;
};

export const infoPublishInfoService = async (
  cred: object,
): Promise<Publishinfo> => {
  const { data } = await axiosInstance.post<ApiResponse<Publishinfo>>(
    '/api/shift/publishinfo',
    cred,
  );
  return data.data;
};

export const publishInfoService = async (
  cred: object,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shift/publish',
    cred,
  );
  return data;
};

export const copyperiodService = async (
  values: ShiftCopyPeriod,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shift/copyperiod',
    values,
  );
  return data;
};

export const GetNumberOfUsersToCopyService = async (
  values: ShiftCopyPeriod,
): Promise<ApiResponse<GetNumberOfUsersToCopyType>> => {
  const { data } = await axiosInstance.post<
    ApiResponse<GetNumberOfUsersToCopyType>
  >('/api/shift/GetNumberOfUsersToCopy', values);
  return data;
};

export const GetAvailableusers = async (
  shiftId: number,
): Promise<OptionSelect[]> => {
  const { data } = await axiosInstance.get<ApiResponse<OptionSelect[]>>(
    `/api/shiftdemands/availableusers/${shiftId}`,
  );
  return data.data;
};

export const GetShiftUsersByFunction = async (
  fonctionId: number,
): Promise<SelectOptionResponse[]> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectOptionResponse[]>>(
    `/api/shift/UsersList/${fonctionId}`,
  );
  return data.data;
};

export const ReplaceUserShiftService = async (
  values: CreateRemplace,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shiftdemands/Replace',
    values,
  );
  return data;
};

export const ApproveReplaceService = async (
  values: ApproveReplace,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shiftdemands/approvereplace',
    values,
  );
  return data;
};

export const rejectReplaceService = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    `/api/shiftdemands/rejectreplace/${id}`,
  );
  return data;
};

export const importShiftService = async (
  values: FormData,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shift/import',
    values,
  );
  return data;
};

export const saveTemplateService = async (
  values: SaveTemplateType,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shift/savetemplate',
    values,
  );
  return data;
};

export const listingMyShiftService = async (
  filters: FiltersMyShift,
): Promise<ShiftTableResponse> => {
  const { data } = await axiosInstance.post<ApiResponse<ShiftTableResponse>>(
    '/api/shift/listing',
    filters,
  );
  return data.data;
};

export const replacelistingShiftService = async (
  filters: FiltersDemandeShift,
): Promise<ShiftTableResponse> => {
  const { data } = await axiosInstance.post<ApiResponse<ShiftTableResponse>>(
    '/api/shiftdemands/replacelisting',
    filters,
  );
  return data.data;
};

export const changeListingShiftService = async (
  filters: FiltersDemandeShift,
): Promise<ChangeListingType> => {
  const { data } = await axiosInstance.post<ApiResponse<ChangeListingType>>(
    '/api/shiftdemands/changelisting',
    filters,
  );
  return data.data;
};

export const infoShiftService = async (): Promise<{
  replaceCount: number;
  changeCount: number;
}> => {
  const { data } = await axiosInstance.get<
    ApiResponse<{ replaceCount: number; changeCount: number }>
  >('/api/shiftdemands/info');
  return data.data;
};

export const changeShiftDemandeService = async (
  values: WorkSchedule,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shiftdemands/change',
    values,
  );
  return data;
};

export const getshiftTrackerService = async (
  id: number,
): Promise<ApiResponse<ShiftTracker>> => {
  const { data } = await axiosInstance.get<ApiResponse<ShiftTracker>>(
    `api/Htravail/getshiftTracker/${id}`,
  );
  return data;
};

export const ChangeStatusShiftTrackerService = async (
  values: ChangeStatusShiftTrackerType,
): Promise<ApiResponse<string>> => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    '/api/Htravail/ChangeStatusShiftTracker',
    values,
  );
  return data;
};

export const ApproveChangeService = async (
  values: ApproveChange,
): Promise<ApiResponse<string>> => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    '/api/shiftdemands/approvechange',
    values,
  );
  return data;
};

export const rejectDemandeService = async (
  values: ApproveChange,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/shiftdemands/rejectchange',
    values,
  );
  return data;
};

export const importfileService = async (): Promise<void> => {
  const { data } = await axiosInstance.get<ArrayBuffer>(
    '/api/shift/importfile',
    {
      responseType: 'arraybuffer',
    },
  );

  downloadExcelBuffer(data, 'ImportShiftModel.xlsx');
};

export const exportShiftService = async (
  filters: ShiftParametres,
): Promise<void> => {
  const { data } = await axiosInstance.post<ArrayBuffer>(
    '/api/shift/export',
    filters,
    {
      responseType: 'arraybuffer',
    },
  );
  downloadExcelBuffer(data, 'export.xlsx');
};

export const exportReportShiftService = async (
  filters: ShiftParametres,
): Promise<void> => {
  const { data } = await axiosInstance.post<ArrayBuffer>(
    '/api/shift/exportreport',
    filters,
    {
      responseType: 'arraybuffer',
    },
  );
  downloadExcelBuffer(data, 'export.xlsx');
};
